import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Summary_Scaleless_1({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Compact name styles
  const nameStyle = {
    fontSize: isSub ? "12px" : "14px",
    fontWeight: "600",
    padding: "1px 6px",
    textAlign: "left",
    lineHeight: "1.1",
    display: "flex",
    alignItems: "center",
  };

  // Container style with borders
  const containerStyle = {
    borderLeft: "3px solid #f6c344",
    borderRight: "3px solid #f6c344",
    borderRadius: "6px",
    padding: "3px 8px",
    backgroundColor: "#e7e7e7",
  };

  return (
    <Row
      style={{
        height: "auto",
        marginBottom: "4px",
        padding: "0",
      }}
    >
      <div style={containerStyle}>
        <Row className="align-items-center" style={{ margin: "0", display: "flex", alignItems: "center" }}>
          <Col xs="auto" style={nameStyle}>
            {item.name}
          </Col>
          <Col xs="auto" style={{ padding: "0", display: "flex", alignItems: "center" }}>
            <div
              className={
                (!isSub ? "_main-scope-score-header-pdf-detail-new" : "_sub-scope-score-pdf") + " _flex-center"
              }
            >
              {elementScore}
            </div>
          </Col>
        </Row>
      </div>
    </Row>
  );
}
